import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["grow", "minHeight", "title"];
// import PropTypes from 'prop-types';
import unescapedText from 'I18n/utils/unescapedText';
import { keyframes } from 'styled-components';
import styled from 'foundations-theming/utils';
// import createLazyPropType from '../utils/propTypes/createLazyPropType';
import { lazyEval } from '../../utils/lazyEval';
import { useMapTokenPropsToCSS } from '../../../hooks/useMapTokenPropsToCSS';
import { filterProps } from '../../../utils/filterProps';
import { toPx } from '../../../utils/toPx';

/** @internal */
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const loadingColorAnimation = props => keyframes(["25%{background-color:", ";}75%{background-color:", ";"], props.theme.color['border-core-default'], props.theme.color['border-core-default']);
const loadingAnimation = keyframes(["0%,100%{transform:translateY(0);}25%{transform:translateY(.25em);}50%{transform:translateY(0);}75%{transform:translateY(-.25em);}"]);
const Dot = styled.div.withConfig({
  displayName: "LoadingDots__Dot",
  componentId: "sc-1a1dvyq-0"
})(["position:relative;background-color:currentColor;color:", ";border-radius:50%;height:1em;width:1em;animation:", ",", ";animation-duration:1s;animation-timing-function:linear;animation-iteration-count:infinite;&:not(:last-child){margin-right:0.75em;}&:nth-child(2){animation-delay:-0.66s;}&:nth-child(3){animation-delay:-0.33s;}"], ({
  theme
}) => theme.color['icon-interactive-default'], loadingAnimation, loadingColorAnimation);
const StyledLoadingDots = styled.div.withConfig({
  displayName: "LoadingDots__StyledLoadingDots",
  componentId: "sc-1a1dvyq-1"
})(["display:flex;align-items:center;justify-content:center;height:1.25em;width:4.5em;min-height:", ";", ";", ";"], props => props.$minHeight && toPx(props.$minHeight), props => props.grow && `width: 100%; height: 100%;`, ({
  $cssStyles
}) => $cssStyles);
const getTranslatedTitle = () => unescapedText('salesUI.UILoading.title');
export const LoadingDots = _ref => {
  let {
      grow = true,
      minHeight,
      title = getTranslatedTitle()
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    tokenProps,
    domProps
  } = filterProps(rest);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  return /*#__PURE__*/_jsxs(StyledLoadingDots, Object.assign({
    $minHeight: minHeight,
    $cssStyles: cssStyles,
    "data-loading": true,
    title: lazyEval(title),
    grow: grow
  }, domProps, {
    children: [/*#__PURE__*/_jsx(Dot, {}), /*#__PURE__*/_jsx(Dot, {}), /*#__PURE__*/_jsx(Dot, {})]
  }));
};
LoadingDots.displayName = 'LoadingDots';